<template>
  <div class="conteudoInterno" id="distribuicao">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Distribuição</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPinkBack"></span>
        </div>
        <div class="col66 top32">
          <p>
            O principal objetivo do sistema de gestão coletiva é pagar aos
            detentores dos direitos pelo uso de suas criações. Para isso,
            devemos ser precisos, eficientes, transparentes e pontuais.
          </p>
          <p>
            Como a UBC representa alguns dos maiores e mais ativos repertórios
            do mundo, tanto nacionais quanto internacionais, a infraestrutura
            interna e sua conexão com o Ecad estão em constante evolução para
            acompanhar a demanda, sem nunca sacrificar os serviços e recursos
            que oferecemos.
          </p>
          <p>
            Os números a seguir se baseiam novamente nas informações totais do
            Ecad, para refletir de uma forma precisa o conjunto do mercado
            brasileiro. Reiteramos que a parte final do relatório traz os
            números específicos da UBC.
          </p>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            O valor total distribuído em 2025 foi de
            <span class="ubcPink Green sanukBlack">R$ 1,725 bilhões,</span> um
            <span class="ubcPink Green sanukBlack">crescimento de 9,95%</span>
            em relação a 2024.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col32">
          <h3>Evolução das cifras de distribuição</h3>
          <div class="evolucaoDistribuicao top20">
            <span>2021</span>
            <h4 class="sanukBlack ubcPink">R$ 901,6 milhões</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2022</span>
            <h4 class="sanukBlack ubcPink">R$ 1,232 bilhão</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2023</span>
            <h4 class="sanukBlack ubcPink">R$ 1,391 bilhão</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2024</span>
            <h4 class="sanukBlack ubcPink">R$1,569 bilhão</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2025</span>
            <h4 class="sanukBlack ubcPink">R$ 1,725 bilhão</h4>
          </div>
          <p>
            Em 2025,
            <span class="sanukBold"
              >foram contemplados mais de 345 mil titulares.</span
            >
            Na parte autoral, 77% dos titulares contemplados foram nacionais;
            23%, estrangeiros. Na parte conexa, 80% foram titulares nacionais;
            20%, estrangeiros.
          </p>
        </div>
        <div class="col57ponto6 topMob32">
          <h3>Participação na distribuição, por categoria</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <BarChart />
            </div>
          </div>
          <!-- <div class="top20">
            <PieChart2 />
          </div> -->
          <!-- <p class="note top20">
            Nota: os royalties arrecadados de Usuários Gerais para os quais não existem dados de uso disponíveis são somados às distribuições tanto de TV aberta como de Rádio, com uma divisão de distribuição de 5%/95%, respectivamente.
          </p> -->
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col100">
          <h3>Detalhamento da distribuição por tipo de direitos:</h3>
          <SwipperMobile />
          <div class="top20 tableContainer">
            <table>
              <thead>
                <tr>
                  <th align="left">
                    <span class="sanukBold">Segmentos</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">2024</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">%</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">2025</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">%</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">Diferença</span>
                  </th>
                  <th align="right">
                    <span class="sanukBold">Var (%)</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Carnaval</td>
                  <td align="right">R$ 24.636.572,30</td>
                  <td align="right">1,57%</td>
                  <td align="right">R$ 33.217.093,44</td>
                  <td align="right">1,92%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 8.580.521,14
                  </td>
                  <td class="sanukBold ubcBlue" align="right">34,83%</td>
                </tr>
                <tr>
                  <td>Casas de Festas e Diversão</td>
                  <td align="right">R$ 49.258.610,41</td>
                  <td align="right">3,14%</td>
                  <td align="right">R$ 55.427.385,48</td>
                  <td align="right">3,21%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 6.168.775,07
                  </td>
                  <td class="sanukBold ubcBlue" align="right">12,52%</td>
                </tr>
                <tr>
                  <td>Cinema</td>
                  <td align="right">R$ 42.174.748,89</td>
                  <td align="right">2,69%</td>
                  <td align="right">R$ 30.992.400,34</td>
                  <td align="right">1,80%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ -11.182.348,55
                  </td>
                  <td class="sanukBold ubcBlue" align="right">-26,51%</td>
                </tr>
                <tr>
                  <td>Festa Junina</td>
                  <td align="right">R$ 6.104.228,09</td>
                  <td align="right">0,39%</td>
                  <td align="right">R$ 8.568.176,94</td>
                  <td align="right">0,50%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 2.463.948,85
                  </td>
                  <td class="sanukBold ubcBlue" align="right">40,36%</td>
                </tr>
                <tr>
                  <td>Música ao Vivo</td>
                  <td align="right">R$ 43.605.345,92</td>
                  <td align="right">2,78%</td>
                  <td align="right">R$ 52.757.589,41</td>
                  <td align="right">3,06%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 9.152.243,49
                  </td>
                  <td class="sanukBold ubcBlue" align="right">20,99%</td>
                </tr>
                <tr>
                  <td>Rádios+DG</td>
                  <td align="right">R$ 295.484.391,75</td>
                  <td align="right">18,82%</td>
                  <td align="right">R$ 319.319.836,39</td>
                  <td align="right">18,50%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 23.835.444,64
                  </td>
                  <td class="sanukBold ubcBlue" align="right">8,07%</td>
                </tr>
                <tr>
                  <td>Serviços Digitais</td>
                  <td align="right">R$ 9.490.696,65</td>
                  <td align="right">0,60%</td>
                  <td align="right">R$ 10.165.829,42</td>
                  <td align="right">0,59%</td>
                  <td class="sanukBold ubcBlue" align="right">R$ 675.132,77</td>
                  <td class="sanukBold ubcBlue" align="right">7,11%</td>
                </tr>
                <tr>
                  <td>Shows</td>
                  <td align="right">R$ 219.368.656,74</td>
                  <td align="right">13,98%</td>
                  <td align="right">R$ 254.058.991,38</td>
                  <td align="right">14,72%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 34.690.334,64
                  </td>
                  <td class="sanukBold ubcBlue" align="right">15,81%</td>
                </tr>
                <tr>
                  <td>Sonorização Ambiental</td>
                  <td align="right">R$ 68.614.036,78</td>
                  <td align="right">4,37%</td>
                  <td align="right">R$ 73.395.424,03</td>
                  <td align="right">4,25%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 4.781.387,25
                  </td>
                  <td class="sanukBold ubcBlue" align="right">6,97%</td>
                </tr>
                <tr>
                  <td>Streaming de áudio</td>
                  <td align="right">R$ 163.026.643,72</td>
                  <td align="right">10,39%</td>
                  <td align="right">R$ 174.420.206,12</td>
                  <td align="right">10,11%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 11.393.562,40
                  </td>
                  <td class="sanukBold ubcBlue" align="right">6,99%</td>
                </tr>
                <tr>
                  <td>Streaming de vídeo</td>
                  <td align="right">R$ 199.812.236,72</td>
                  <td align="right">12,73%</td>
                  <td align="right">R$ 231.720.040,43</td>
                  <td align="right">13,43%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 31.907.803,71
                  </td>
                  <td class="sanukBold ubcBlue" align="right">15,97%</td>
                </tr>
                <tr>
                  <td>Tv Aberta+DG</td>
                  <td align="right">R$ 254.848.703,19</td>
                  <td align="right">16,24%</td>
                  <td align="right">R$ 268.535.688,44</td>
                  <td align="right">15,56%</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ 13.686.985,25
                  </td>
                  <td class="sanukBold ubcBlue" align="right">5,37%</td>
                </tr>
                <tr>
                  <td>Tv Fechada</td>
                  <td align="right">R$ 193.233.551,23</td>
                  <td align="right">12,31 %</td>
                  <td align="right">R$ 191.484.997,50</td>
                  <td align="right">11,10 %</td>
                  <td class="sanukBold ubcBlue" align="right">
                    R$ -1.748.553,73
                  </td>
                  <td class="sanukBold ubcBlue" align="right">-0,90%</td>
                </tr>
                <tr>
                  <td><span class="sanukBold">Total</span></td>
                  <td align="right">
                    <span class="sanukBold">R$ 1.569.658.422,39</span>
                  </td>
                  <td align="right"><span class="sanukBold">-</span></td>

                  <td align="right">
                    <span class="sanukBold">R$ 1.725.642.718,57</span>
                  </td>
                  <td align="right">
                    <span class="sanukBold">-</span>
                  </td>
                  <td align="right">
                    <span class="sanukBold">-</span>
                  </td>
                  <td align="right"><span class="sanukBold">-</span></td>
                </tr>
                <tr>
                  <td>Demais Segmentos</td>
                  <td class="sanukBold" align="right">R$ -283.909,57</td>
                  <td align="right">-</td>
                  <td class="sanukBold" align="right">R$ -145.717,67</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                </tr>
                <tr>
                  <td>
                    <span class="sanukBold"
                      >Total Geral com "Demais Segmentos"</span
                    >
                  </td>
                  <td align="right">
                    <span class="sanukBold">R$ 1.569.374.512,82</span>
                  </td>
                  <td align="right">-</td>
                  <td align="right">
                    <span class="sanukBold">R$ 1.725.497.000,90</span>
                  </td>
                  <td align="right">
                    <span class="sanukBold">-</span>
                  </td>
                  <td align="right">
                    <span class="sanukBold">-</span>
                  </td>
                  <td align="right"><span class="sanukBold">-</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tableNote" style="margin-bottom: 1rem">
            *<span class="sanukBold">Demais Segmentos</span>: "Indireta - Até
            Nov/97"; "Retenção Judicial", "Dívida do Titular", "Ex-Direitos
            Gerais" e "Ex-Músico Acompanhante".
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
// import PieChart2 from "./Grafico3.vue";
import BarChart from "./Grafico4.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "DistribuicaoPage",
  props: ["clicked"],
  components: {
    // PieChart2,
    BarChart,
    SwipperMobile,
  },
  data() {
    return {
      setaScrollState: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#distribuicao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.evolucaoDistribuicao h4 {
  font-size: 24px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(3) h4 {
  font-size: 27px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(4) h4 {
  font-size: 30px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(5) h4 {
  font-size: 33px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(6) h4 {
  font-size: 36px;
}
.note {
  padding-left: 160px;
}

.graphContainer {
  padding-top: 30px;
  width: 100%;
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar {
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb {
  background-color: #ec1651;
  border-radius: 10px;
  border: 5px solid white;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.graph {
  min-width: 500px;
  min-height: 400px;
}

table {
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  font-size: 14px;
  min-width: 1024px;
}

table thead {
  background-color: #ec1651;
  color: #fff;
}

table thead tr th {
  padding: 15px 0;
  vertical-align: middle;
}

table thead tr th:first-child {
  padding-left: 2%;
}
table thead tr th:last-child {
  padding-right: 2%;
}

table tbody tr:nth-child(even) {
  background-color: #f6f6f6;
}

table tbody tr td {
  padding: 15px 0;
  vertical-align: middle;
  font-size: 12px;
}

table tbody tr {
  position: relative;
}

table tbody tr td:first-child {
  padding-left: 2%;
  position: sticky;
  left: 0;
  background: #fff;
}

table tbody tr:nth-child(even) td:first-child {
  background-color: #f6f6f6;
}

table tbody tr td:last-child {
  padding-right: 2%;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.subColYear {
  font-family: "sanuk-bold";
  color: #ec1651;
}

@media screen and (max-width: 1200px) {
  .tableContainer {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 500px) {
  .note {
    padding-left: 0;
  }
}
</style>
